<template>
<div class="main-container">
  <div v-if="isAdmin">
    <home-admin />
  </div>
  <div v-else>
    <div class="headTip">
      <el-card shadow="hover">
        <div>{{headTip}}</div>
        <el-button type="text" class="to-do" v-if="notVerifyLists.total > 0" :disabled="$has('goodsManageNotVerify')" @click="$router.push({ path: `/goodsmanage/notverify` })">
          待办事项：未审商品<span class="red">{{ notVerifyLists.total }}</span>个
        </el-button>
        <!-- <div class="to-do" v-if="notVerifyList.total > 0 && !$has('goodsManageNotVerify')" @click="$router.push({ path: `/goodsmanage/notverify` })">待办事项：未审商品<span class="red">{{ notVerifyList.total }}</span>个</div> -->
      </el-card>
    </div>
    <div class="flex">
      <el-card class="box-card height-1" shadow="hover">
        <div class="sum-total flexCenter">
          <img src="@/assets/images/home/icon-num1.png" alt="">
          <div>
            <p>总库存（件）</p>
            {{count.inventory|numFormat}}
          </div>
        </div>
        <el-tooltip class="tips" content="当前在库总库存数量" placement="right-start">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </el-card>
      <el-card class="box-card height-1" shadow="hover">
        <div class="sum-total flexCenter">
          <img src="@/assets/images/home/icon-num2.png" alt="">
          <div>
            <p>供应商总数</p>
            {{count.supplier|numFormat}}
          </div>
        </div>
        <el-tooltip class="tips" content="近30天有出入库记录的供应商数量" placement="right-start">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </el-card>
      <el-card class="box-card height-1" shadow="hover">
        <div class="sum-total flexCenter">
          <img src="@/assets/images/home/icon-num3.png" alt="">
          <div>
            <p>SKU总数</p>
            {{count.sku|numFormat}}
          </div>
        </div>
        <el-tooltip class="tips" content="一个商品编码为一个SKU只统计总库存>0的商品" placement="right-start">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </el-card>
      <el-card class="box-card height-1" shadow="hover">
        <div class="sum-total flexCenter">
          <img src="@/assets/images/home/icon-num41.png" alt="">
          <div>
            <p>总货值(元)</p>
            {{count.value|numFormat}}
          </div>
        </div>
        <el-tooltip class="tips" placement="right-start">
          <div slot="content">单品货值：在库库存*销售价<br />总货值：所有单品货值之和</div>
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </el-card>
    </div>

    <div>
      <div class="flex">
        <el-card class="box-card height-2" shadow="hover">
        <h3>今日出入库任务</h3>
        <div class="flex">
          <div class="task">
            <div class="task-item">
              未接单
              <span class="red">{{task.notAccept}}</span>个
            </div>
            <div class="task-item">
              进行中
              <span class="blue">{{task.progress}}</span>个
            </div>
            <div class="task-item">
              完成和取消
              <span>{{task.completed + task.cansel}}</span>个
            </div>
          </div>
          <div id="myChart" ref="taskChart" style="height:350px;flex:1"></div>
        </div>
      </el-card>
      <el-card class="box-card height-2" shadow="hover" style="flex: 0.75">
        <h3>供应商出货量排名TOP10</h3>
        <el-tooltip class="tips" content="已生成的账单（已支付+未支付）总金额" placement="right-start">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
        <div class="shipment-filter flex">
          <span :class="total.activeDate == 1 ? 'active':''" @click="changeTotal(1)">近1月</span>
          <span :class="total.activeDate == 2 ? 'active':''" @click="changeTotal(2)">近1年</span>
        </div>
        <p class="nothing" v-if="total.list.length == 0">暂无数据</p>
        <div class="total" >
          <div class="totalChart-list flex">
              <el-tooltip v-for="(item,index) in total.list" :key="index" class="item" effect="dark" :content="item.name" placement="top" :enterable="false" :open-delay="1000">
                <span class="item"></span>
              </el-tooltip>
          </div>
          <div id="myChart" ref="totalChart" v-if="total.isShow" :style="'height:' + height"></div>
        </div>
      </el-card>
      <el-card class="box-card height-2" shadow="hover" style="flex: 0.75">
        <h3>近一年未支付账单累计<span>共{{ unpaidList.totalMoney }}元</span></h3>
        <el-tooltip class="tips" content="一年内生成的账单中，未支付的账单累计" placement="right-start">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
        <p class="nothing" v-if="unpaidList.list.length == 0" style="margin-top:150px">暂无数据</p>
        <div class="unpaid" v-if="unpaidList.list.length">
          <ul class="title">
            <li class="flex">
              <span>排名</span>
              <span>供应商</span>
              <span>笔数</span>
              <span>账单金额</span>
            </li>
          </ul>
          <div class="unpaid-scroll">
            <ul id="unpaid" ref="unpaid" :class="{ anim: unpaid.animate == true }" @mouseenter="mEnter" @mouseleave="mLeave">
              <li class="flex" v-for="(item,index) in unpaidList.list" :key="index">
                <span>{{ item.ranking }}</span>
                <el-tooltip :content="item.supplierName" placement="top" :enterable="false" :open-delay="1000">
                  <span class="text-hidden">{{ item.supplierName }}</span>
                </el-tooltip>
                <span>{{ item.number }}</span>
                <span>{{ item.money | toFixed }}</span>
              </li>
            </ul>
          </div>
        </div>
      </el-card>
      </div>
      <div>
        <el-card class="box-card height-3" shadow="hover">
          <h3>仓库出货量统计<span v-if="shipment.list.wareHouseName.length > 4">期间总出货量最高的前五个仓库</span></h3>
          <el-tooltip class="tips" content="出货+补货任务实际完成数量之和" placement="right-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          <div class="shipment-filter flex">
            <span :class="shipment.activeDate == 1 ? 'active':''" @click="changeShipment(1, 'date')">近7天</span>
            <span :class="shipment.activeDate == 2 ? 'active':''" @click="changeShipment(2, 'date')">近1月</span>
            <img src="@/assets/images/home/shipment-1.png" @click="changeShipment(1, 'chart')">
            <img src="@/assets/images/home/shipment-2.png" @click="changeShipment(2, 'chart')">
          </div>
          <div v-if="shipment.isShow" id="shipmentCharts" ref="shipmentCharts" style="height:300px"></div>
        </el-card>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import * as echarts from 'echarts'
import home from '@/store/home/index.js'
import { GETSUPPLIERCOUNT, GETUNPAIDBILLINONEYEAR, GETBILLTOTALMONEYRANKING, GETHEADTIP, GETNOWEXTSKUTASK, GETMAXSOLD } from '@/store/home/types.js'
import { splitNum } from '@/page/dataCenter/components/js/computedSplitNum'
import goodsManage from '@/store/goodsManage/index.js'
import { GETNOTPASSGOODS } from '@/store/goodsManage/types.js'
import homeAdmin from './Home-admin'
export default {
  name: 'home',
  data () {
    return {
      // 近一年未支付账单累计
      unpaid: {
        animate: false
      },
      // 仓库出货量统计
      shipment: {
        isShow: true,
        list: {wareHouseName: []},
        activeDate: 1,
        activeChart: 1
      },
      // 供应商账单总金额排名TOP10
      total: {
        isShow: true,
        activeDate: 1,
        list: []
      }
    }
  },
  computed: {
    // 供应商总数
    count () {
      return home.state.count
    },
    // 今日任务数
    task () {
      return home.state.task
    },
    // 近一年未支付账单累计
    unpaidList () {
      return home.state.unpaidList
    },
    // 顶部提示
    headTip () {
      return home.state.headTip
    },
    // 仓库出货量统计
    shipments () {
      return home.state.shipment
    },
    // 是否为超级管理员
    isAdmin () {
      return window.localStorage.getItem('identity') === '3'
    },
    height () {
      return this.total.list.length * 33 + 'px'
    },
    // 未审商品列表
    notVerifyLists () {
      return goodsManage.state.notVerifyLists
    }
  },
  mounted () {
    if (this.isAdmin) return false
    this.totalChart()
    this.getSupplierCount()
    this.getUnpaid()
    this.shipmentCharts()
    this.getHeadTip()
    this.getCount()
    this.getNotVerifyList()
  },
  methods: {
    // 图表 - 今日任务数
    taskChart () {
      var myChart = echarts.init(this.$refs.taskChart)
      let list = this.task.chartsData.map(item => {
        return {
          name: `${item.name}：${item.value}个`,
          value: item.value,
          number: item.number
        }
      })
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (param) {
            var data = param.data
            var res = '计划数量共' + data.number + '件'
            return res
          }
        },
        series: [
          {
            name: '类型',
            type: 'pie',
            top: '0%',
            radius: [50, 80],
            center: ['50%', '50%'],
            data: list,
            labelLine: {
              normal: {
                length: 10,
                length2: 10
              }
            }
          }
        ]
      })
    },
    // 图表 - 仓库出货量统计
    shipmentCharts () {
      let parms = {
        day: this.shipment.activeDate === 1 ? 7 : 30
      }
      this.shipment.isShow = false
      this.$store.dispatch(GETMAXSOLD, parms).then(res => {
        this.shipment.isShow = true
        this.shipment.list = res
        this.$nextTick(() => {
          var myChart = echarts.init(this.$refs.shipmentCharts)
          let option = {
            tooltip: {
              trigger: 'axis'
            },
            grid: {
              top: '3%',
              left: '3%',
              right: '4%',
              bottom: '10%',
              containLabel: true
            },
            yAxis: {
              type: 'value',
              max: (value) => {
                if (value.max < 5) {
                  return 5
                } else {
                  return splitNum(value.max)
                }
              }

            },
            legend: {
              top: 'bottom',
              data: res.wareHouseName
            }
          }
          let config = {
            axisLabel: {
              show: true,
              interval: 0,
              rotate: this.shipment.activeDate === 1 ? 0 : 40,
              textStyle: {
                color: '#333'
              }
            }
          }
          let options = {
            1: {
              ...option,
              xAxis: [
                {
                  axisTick: {
                    alignWithLabel: true
                  },
                  ...config,
                  type: 'category',
                  data: res.dayList
                }
              ],
              series: res.wareHouseDaylist.map(item => {
                return {
                  name: item.name,
                  data: item.data,
                  type: 'bar',
                  barWidth: this.shipment.activeDate === 1 ? 20 : 0,
                  stack: '出货量',
                  emphasis: {
                    focus: 'series'
                  }
                }
              })
            },
            2: {
              ...option,
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: res.dayList,
                ...config
              },
              series: res.wareHouseDaylist.map(item => {
                return {
                  name: item.name,
                  data: item.data,
                  type: 'line',
                  // stack: '总量',
                  smooth: true
                }
              })
            }
          }
          myChart.setOption(options[this.shipment.activeChart])
        })
      })
    },
    // 图表 - 供应商账单总金额排名TOP10
    totalChart () {
      this.total.isShow = false
      let parms = {
        type: this.total.activeDate
      }
      this.$store.dispatch(GETBILLTOTALMONEYRANKING, parms).then(res => {
        if (!res) return false
        this.total.isShow = true
        this.total.list = res.yAxis.map((item, index) => {
          return {
            name: item,
            number: res.series[index]
          }
        })
        this.total.list.reverse()
        this.$nextTick(() => {
          var myChart = echarts.init(this.$refs.totalChart)
          myChart.setOption({
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: '0%',
              left: '3%',
              right: '13%',
              bottom: '0%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              show: false
            },
            yAxis: {
              type: 'category',
              data: res.yAxis,
              splitLine: {show: false},
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              offset: 10,
              nameTextStyle: {
                fontSize: 15
              },
              axisLabel: {
                interval: 0,
                formatter: function (value) {
                  if (value.length > 7) {
                    return value.substring(0, 7) + '...'
                  } else {
                    return value
                  }
                }
              }
            },
            series: [
              {
                name: '总金额',
                type: 'bar',
                data: res.series,
                barWidth: 14,
                barGap: 10,
                smooth: true,
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    offset: [5, 2],
                    textStyle: {
                      color: '#F68300',
                      fontSize: 13
                    }
                  }
                },
                itemStyle: {
                  emphasis: {
                    barBorderRadius: 7
                  },
                  normal: {
                    barBorderRadius: 7,
                    color: new echarts.graphic.LinearGradient(
                      0, 0, 1, 0,
                      [
                        {offset: 0, color: '#3977E6'},
                        {offset: 1, color: '#37BBF8'}
                      ]
                    )
                  }
                }
              }
            ]
          })
        })
      })
    },
    // 查询供应商总数
    getSupplierCount () {
      this.$store.dispatch(GETSUPPLIERCOUNT)
    },
    // 近一年未支付账单累计 - 列表
    getUnpaid () {
      this.$store.dispatch(GETUNPAIDBILLINONEYEAR)
    },
    // 获取总库存、sku种数、今日任务数
    getCount () {
      this.$store.dispatch(GETNOWEXTSKUTASK)
    },
    // 近一年未支付账单累计 - 滚动
    unpaidScroll () {
      document.getElementById('unpaid').style.marginTop = '-36px'
      this.unpaid.animate = !this.unpaid.animate
      setTimeout(() => {
        this.unpaidList.list.push(this.unpaidList.list[0])
        this.unpaidList.list.shift()
        this.$refs.unpaid.style.marginTop = '0px'
        this.unpaid.animate = !this.unpaid.animate
      }, 500)
    },
    mEnter () {
      clearInterval(this.timer)
    },
    mLeave () {
      if (this.unpaidList.list.length > 8) {
        this.timer = setInterval(this.unpaidScroll, 3000)
      }
    },
    // 顶部提示
    getHeadTip () {
      this.$store.dispatch(GETHEADTIP)
    },
    // 仓库出货量 - 筛选
    changeShipment (i, type) {
      if (type === 'date') {
        this.shipment.activeDate = i
      } else {
        this.shipment.activeChart = i
      }
      this.shipmentCharts()
    },
    // 供应商账单总金额排名TOP10 - 筛选
    changeTotal (i) {
      this.total.activeDate = i
      setTimeout(() => {
        this.totalChart()
      }, 10)
    },
    // 获取未审商品列表
    getNotVerifyList () {
      let warehouseCode = []
      let arr = JSON.parse(localStorage.getItem('warehouseCodes'))
      for (let i = 0; i < arr.length; i++) {
        warehouseCode[warehouseCode.length] = arr[i].value
      }
      let warehouseCodes = warehouseCode.join()
      let parms = {
        page: 1,
        rows: 10,
        warehouseCode: warehouseCodes
      }
      this.$store.dispatch(GETNOTPASSGOODS, parms)
    }

  },
  watch: {
    unpaidList: {
      deep: true,
      handler (val) {
        if (val.list.length > 8 && !this.timer) {
          this.timer = setInterval(this.unpaidScroll, 3000)
        }
      }
    },
    'task.chartsData': {
      deep: true,
      handler (val) {
        this.taskChart()
      }
    },
    shipments: {
      deep: true,
      handler (val) {
        this.shipmentCharts()
      }
    }
  },
  filters: {
    numFormat (num) {
      if (!num || num === 0) return 0
      var c = (num.toString().indexOf('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return c
    },
    toFixed (num) {
      return num.toFixed(2)
    }
  },
  components: {
    homeAdmin
  },
  beforeRouteLeave (to, form, next) {
    this.mEnter()
    next()
  }
}
</script>
<style scoped>
  .headTip {
    color: #999;
    font-size: 15px;
    opacity: 1;
    transition: all 1s;
  }
  .headTip .el-card__body {
    display: flex;
  }
  .headTip .el-card__body div:first-child {
    flex: 1;
    margin-right: 50px;
  }
  .headTip .el-card__body .to-do {
    font-size: 16px !important;
    color: #666;
  }
  .headTip .red {
    color: red;
  }
  .box-card {
    width: 100%;
    flex: 1;
  }
  .flex {
    display: flex;
  }
  .flexCenter {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-hidden {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .height-1 {
    height: 100px;
  }
  .height-2 {
    height: 380px;
  }
  .height-3 {
    height: 420px;
  }
  .box-card {
    position: relative;
  }
  .box-card .tips {
    position: absolute;
    top: 16px;
    right: 16px;
  }
  h3 {
    font-size: 15px;
  }
  h3 span {
    font-weight: 400;
    font-size: 13px;
    color: #999;
    margin-left: 10px;
  }
  /* 总库存、供应商总数、SKU总数 */
  .sum-total {
    height: 65px;
  }
  .sum-total img {
    width: 50px;
  }
  .sum-total div {
    margin-left: 25px;
    color: #222222;
    font-size: 25px;
  }
  .sum-total p {
    font-size: 15px;
    color: #606266;
    margin-bottom: 15px;
  }
  /* 近一年未支付账单累计 */
  .unpaid .unpaid-scroll {
    height: 296px;
    transition: all 0.5s;
    overflow: hidden;
  }
  .unpaid ul li {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #eee;
  }
  .unpaid ul li span {
    font-size: 14px;
    flex: 1;
    text-align: center;
  }
  .unpaid ul li span:nth-child(1) {
    width: 20%;
    flex: inherit;
  }
  .unpaid ul li span:nth-child(2) {
    /* text-align: left; */
  }
  .unpaid ul li span:nth-child(3) {
    color: #FF5B5B;
  }
  .unpaid ul li span:last-child {
    color: #5B9CFF;
  }
  .unpaid .anim {
    transition: all 0.5s;
  }
  .unpaid .title {
    font-size: 16px;
    font-weight: 700;
    margin-top: 20px;
  }
  .unpaid .title span {
    font-size: 15px;
    color: #333 !important;
  }
  .nothing {
    color: #999;
    text-align: center;
    margin-top: 120px;
  }
  /* 仓库出货量统计 */
  .shipment-filter {
    justify-content: flex-end;
    align-items: center;
    margin: 10px 0 10px;
  }
  .shipment-filter span,
  .shipment-filter img {
    cursor: pointer;
    margin-right: 30px;
  }
  .shipment-filter span {
    font-size: 14px;
  }
  .shipment-filter span.active {
    color: #5B9CFF;
  }
  .shipment-filter img {
    width: 20px;
  }
  /* 今日任务数 */
  .task {
    width: 130px;
  }
  .task-item {
    height: 110px;
    line-height: 120px;
    font-size: 11px;
    flex: 1;
    text-align: center;
  }
  .task div:nth-child(3){
    margin-left: -29px;
  }
  .task-item span {
    font-size: 30px;
    font-weight: 700;
  }
  .task-item span.red {
     color: #FF5B5B;
  }
  .task-item span.blue {
     color: #5B9CFF;
  }
  /* 供应商账单总金额排名TOP10 */
  .total {
    position: relative;
  }
  .totalChart-list {
    padding-bottom: 20px;
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
  }
  .totalChart-list .item {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/home/Home.vue